export default __webpack_public_path__ + "static/media/logo192x192white.37ec3f3a.png";